if (!customElements.get('product-stories')) {
  class ProductStories extends HTMLElement {
    constructor() {
      super();

      this.gridStories = this.querySelectorAll('[data-product-story-grid]');
      this.gridPlaceholderButtons = this.querySelectorAll('[data-product-story-grid-placeholder-button]');

      this.standardCarouselSwiperInit();
      this.featuredCarouselSwiperInit();
      this.mobileSwiperInit();
      this.storySwiperInit();

      if (this.gridPlaceholderButtons) {
        this.gridPlaceholderButtons.forEach((gridPlaceholderButton) => {
          gridPlaceholderButton.addEventListener('click', this.gridShowStory.bind(this));
        });

        this.addEventListener('productGridGoToStory', (event) => {
          this.gridShowStory(null, event.detail);
        });
      }
    }

    gridShowStory(event, index) {
      const placeholderButtonIndex = event ? event.target.getAttribute('data-index') : index;

      this.gridStories.forEach((story) => {
        const storyIndex = story.getAttribute('data-index');

        if (storyIndex == placeholderButtonIndex) {
          const scrollPosition = window.scrollY;
          story.classList.remove('d-none');

          if (event && event.target) {
            story.focus();
          }

          this.dispatchEvent(new Event('goToStoryFirstSlide'));
          window.scrollTo(0, scrollPosition);
        } else {
          story.classList.add('d-none');
        }
      });
    }

    mobileSwiperInit() {
      const mobileNav = this.querySelector('[data-product-stories-nav]');
      const mobileNavLoop = mobileNav.hasAttribute('data-product-stories-nav-loop');
      const mobileSwiper = this.querySelector('[data-product-stories-mobile-swiper]');
      let mobileNavSwiper = null;

      function mobileNavSwiperInit() {
        if (window.innerWidth >= 420) {
          if (mobileNav.swiper) {
            mobileNavSwiper.destroy();
          }
        } else {
          mobileNavSwiper = new window.Swiper(mobileNav, {
            spaceBetween: 8,
            slidesPerView: 'auto',
            draggable: true,
            loop: mobileNavLoop
          });
        }
      }

      mobileNavSwiperInit();

      let mobileNavResizeInit;

      window.addEventListener('resize', () => {
        clearTimeout(mobileNavResizeInit);
        mobileNavResizeInit = setTimeout(mobileNavSwiperInit(), 100);
      });

      const swiper = new window.Swiper(mobileSwiper, {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true
      });

      this.addEventListener('goToPrevStory', () => {
        swiper.slidePrev();
      });

      this.addEventListener('goToNextStory', () => {
        swiper.slideNext();
      });

      swiper.on('slideChangeTransitionStart', () => {
        this.dispatchEvent(new Event('goToStoryFirstSlide'));
        updateTabIndex();

        const mobileNavButtons = this.querySelectorAll('[data-product-stories-nav-button]');

        mobileNavButtons.forEach((mobileNavButton) => {
          const index = mobileNavButton.getAttribute('data-index');

          if (swiper.activeIndex > 5) {
            mobileNavButtons.forEach((button) => {
              if (button.getAttribute('data-index') == '1') {
                button.classList.add('active');
              } else {
                button.classList.remove('active');
              }
            });
          } else if (parseInt(index, 10) == swiper.activeIndex) {
            mobileNavButton.classList.add('active');
          } else {
            mobileNavButton.classList.remove('active');
          }
        });
      });

      updateTabIndex();

      function updateTabIndex() {
        const slides = mobileSwiper.querySelectorAll('[data-product-stories-mobile-slide]');

        slides.forEach((slide) => {
          if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('tabindex', 0);

            slide.querySelectorAll('[tabindex], a, button, .swiper-pagination-bullet, video, iframe').forEach((item) => {
              item.setAttribute('tabindex', 0);
            });
          } else {
            slide.setAttribute('tabindex', -1);

            slide.querySelectorAll('[tabindex], a, button, .swiper-pagination-bullet, video, iframe').forEach((item) => {
              item.setAttribute('tabindex', -1);
            });
          }
        });
      }

      mobileNav.addEventListener('click', (event) => {
        if (!event.target.hasAttribute('data-index')) { return; }

        const mobileNavButtons = this.querySelectorAll('[data-product-stories-nav-button]');
        const index = event.target.getAttribute('data-index');

        swiper.slideTo(index);

        mobileNavButtons.forEach((button) => {
          if (button.getAttribute('data-index') == index) {
            button.classList.add('active');
          } else {
            button.classList.remove('active');
          }
        });
      });
    }

    storySwiperInit() {
      const storySwipers = this.querySelectorAll('[data-product-story]');

      storySwipers.forEach((storySwiper) => {
        if (!storySwiper) { return; }

        const avatarWrapper = storySwiper.querySelector('[data-swiper-avatar-wrapper]');
        const prevButton = storySwiper.querySelector('[data-swiper-prev]');
        const nextButton = storySwiper.querySelector('[data-swiper-next]');
        const pagination = storySwiper.querySelector('[data-swiper-pagination]');
        const count = storySwiper.querySelector('[data-swiper-count]');
        const pause = storySwiper.querySelector('[data-swiper-pause]');

        const swiper = new window.Swiper(storySwiper, {
          spaceBetween: 0,
          slidesPerView: 1,
          noSwiping: true,
          noSwipingClass: 'swiper-slide',
          loop: true,
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton
          },
          pagination: {
            el: pagination,
            clickable: true
          },
          autoplay: {
            delay: 6000,
            disableOnInteraction: false
          }
        });

        if (pause) {
          pause.addEventListener('click', () => {
            const allPauseButtons = this.querySelectorAll('[data-swiper-pause]');

            allPauseButtons.forEach((pauseButton) => {
              pauseButton.classList.toggle('active');
            });

            if (pause.classList.contains('active')) {
              this.dispatchEvent(new Event('pauseStories'));
            } else {
              this.dispatchEvent(new Event('startStories'));
            }
          });
        }

        swiper.on('reachBeginning', () => {
          if (storySwiper.closest('[data-product-stories-carousel-slide].swiper-slide-active') || storySwiper.closest('[data-product-stories-mobile-slide].swiper-slide-active')) {
            this.dispatchEvent(new Event('goToPrevStory'));
          }

          if (storySwiper.hasAttribute('data-product-story-grid')) {
            let prevIndex = parseInt(storySwiper.getAttribute('data-index'), 10) - 1;
            const slideCount = this.querySelectorAll('[data-product-story-grid]').length;

            if (prevIndex === 0) {
              prevIndex = slideCount;
            }

            this.dispatchEvent(new CustomEvent('productGridGoToStory', { detail: prevIndex }));
          }
        });

        swiper.on('reachEnd', () => {
          if (storySwiper.closest('[data-product-stories-carousel-slide].swiper-slide-active') || storySwiper.closest('[data-product-stories-mobile-slide].swiper-slide-active')) {
            this.dispatchEvent(new Event('goToNextStory'));
          }

          if (storySwiper.hasAttribute('data-product-story-grid')) {
            let nextIndex = parseInt(storySwiper.getAttribute('data-index'), 10) + 1;
            const slideCount = this.querySelectorAll('[data-product-story-grid]').length;

            if (nextIndex > slideCount) {
              nextIndex = 1;
            }

            this.dispatchEvent(new CustomEvent('productGridGoToStory', { detail: nextIndex }));
          }
        });

        swiper.on('slideChangeTransitionStart', () => {
          if (count) {
            const activeSlide = storySwiper.querySelector('.swiper-slide-active');

            if (activeSlide) {
              count.innerHTML = `0${parseInt(activeSlide.getAttribute('data-swiper-slide-index')) + 1}`;

              if (avatarWrapper) {
                const storySummary = activeSlide.querySelector('[data-product-story-summary]');

                if (storySummary) {
                  avatarWrapper.classList.add('d-none');
                } else {
                  avatarWrapper.classList.remove('d-none');
                }
              }
            }
          }

          const paginationItems = pagination.querySelectorAll('.swiper-pagination-bullet');

          if (paginationItems.length) {
            paginationItems.forEach((paginationItem, index) => {
              if (index + 1 < swiper.activeIndex) {
                paginationItem.classList.add('swiper-pagination-bullet--filled');
              } else {
                paginationItem.classList.remove('swiper-pagination-bullet--filled');
              }
            });
          }

          updateTabIndex();
        });

        this.addEventListener('pauseStories', () => {
          storySwiper.classList.add('swiper-paused');
          swiper.autoplay.stop();
        });

        this.addEventListener('startStories', () => {
          storySwiper.classList.remove('swiper-paused');
          swiper.autoplay.start();
        });

        this.addEventListener('goToStoryFirstSlide', () => {
          swiper.slideTo(1, 0, false);

          setTimeout(() => {
            const paginationItems = pagination.querySelectorAll('.swiper-pagination-bullet');

            if (paginationItems.length) {
              paginationItems.forEach((paginationItem) => {
                paginationItem.classList.remove('swiper-pagination-bullet--filled');
              });
            }
          }, 10);

          if (!storySwiper.classList.contains('swiper-paused')) {
            storySwiper.classList.add('no-animation');
            swiper.autoplay.stop();
            swiper.autoplay.start();

            setTimeout(() => {
              storySwiper.classList.remove('no-animation');
            }, 10);
          }
        });

        storySwiper.addEventListener('mouseover', () => {
          this.classList.add('product-stories--hide-controls');
        });

        storySwiper.addEventListener('mouseleave', () => {
          this.classList.remove('product-stories--hide-controls');
        });

        updateTabIndex();

        function updateTabIndex() {
          if (window.innerWidth > 750) { return; }

          storySwipers.forEach((storySwiper) => {
            if (storySwiper.closest('[data-product-stories-mobile-slide]') && storySwiper.closest('[data-product-stories-mobile-slide]').classList.contains('swiper-slide-active')) {
              storySwiper.querySelectorAll('[tabindex], a, button, .swiper-pagination-bullet').forEach((item) => {
                item.setAttribute('tabindex', 0);
              });
            } else {
              storySwiper.querySelectorAll('[tabindex], a, button, .swiper-pagination-bullet').forEach((item) => {
                item.setAttribute('tabindex', -1);
              });
            }
          });
        }

        return swiper;
      });
    }

    standardCarouselSwiperInit() {
      const carouselWrapper = this.querySelector('[data-product-stories-standard-carousel]');

      if (!carouselWrapper) { return; }

      const carousel = carouselWrapper.querySelector('[data-swiper]');
      const prevButton = carouselWrapper.querySelector('[data-swiper-prev]');
      const nextButton = carouselWrapper.querySelector('[data-swiper-next]');

      const swiper = new window.Swiper(carousel, {
        spaceBetween: 24,
        slidesPerView: 2,
        centeredSlides: true,
        allowTouchMove: false,
        loop: true,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        },
        breakpoints: {
          1025: {
            slidesPerView: 3
          }
        },
      });

      this.addEventListener('goToPrevStory', () => {
        swiper.slidePrev();
        focusActiveSlide();
      });

      this.addEventListener('goToNextStory', () => {
        swiper.slideNext();
        focusActiveSlide();
      });

      function focusActiveSlide () {
        carouselWrapper.querySelectorAll('.swiper-arrow').forEach((swiperArrow) => {
          if (document.activeElement != swiperArrow) { return; }

          setTimeout(() => {
            carouselWrapper.querySelector('.swiper-slide-active .swiper-pagination-bullet').focus();
          }, 200);
        });
      }

      swiper.on('slideChangeTransitionStart', () => {
        this.dispatchEvent(new Event('goToStoryFirstSlide'));
        updateTabIndex();
      });

      updateTabIndex();

      function updateTabIndex() {
        const slides = carousel.querySelectorAll('[data-product-stories-carousel-slide]');

        slides.forEach((slide) => {
          if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('tabindex', 0);
          } else {
            slide.setAttribute('tabindex', -1);
          }
        });
      }

      carousel.addEventListener('click', (event) => {
        if (event.target.classList.contains('swiper-slide-prev')) {
          swiper.slidePrev();
        }

        if (event.target.classList.contains('swiper-slide-next')) {
          swiper.slideNext();
        }
      });

      swiper.update();

      return swiper;
    }

    featuredCarouselSwiperInit() {
      const carouselWrapper = this.querySelector('[data-product-stories-featured-carousel]');

      if (!carouselWrapper) { return; }

      const carousel = carouselWrapper.querySelector('[data-swiper]');
      const prevButton = carouselWrapper.querySelector('[data-swiper-prev]');
      const nextButton = carouselWrapper.querySelector('[data-swiper-next]');

      const swiper = new window.Swiper(carousel, {
        spaceBetween: 24,
        slidesPerView: 2,
        centeredSlides: true,
        allowTouchMove: false,
        loop: true,
        breakpoints: {
          1025: {
            speed: 0,
            slidesPerView: 'auto'
          }
        },
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        }
      });

      this.addEventListener('goToPrevStory', () => {
        swiper.slidePrev();
        focusActiveSlide();
      });

      this.addEventListener('goToNextStory', () => {
        swiper.slideNext();
        focusActiveSlide();
      });

      function focusActiveSlide () {
        carouselWrapper.querySelectorAll('.swiper-arrow').forEach((swiperArrow) => {
          if (document.activeElement != swiperArrow) { return; }

          setTimeout(() => {
            carouselWrapper.querySelector('.swiper-slide-active .swiper-pagination-bullet').focus();
          }, 200);
        });
      }

      swiper.on('slideChangeTransitionStart', () => {
        this.dispatchEvent(new Event('goToStoryFirstSlide'));

        updateTabIndex();

        swiper.update();

        setTimeout(() => {
          swiper.update();
        }, 200);
      });

      updateTabIndex();

      function updateTabIndex() {
        const slides = carousel.querySelectorAll('.product-stories__carousel-slide');

        slides.forEach((slide) => {
          if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('tabindex', 0);
          } else {
            slide.setAttribute('tabindex', -1);
          }
        });
      }

      carousel.addEventListener('click', (event) => {
        if (event.target.classList.contains('swiper-slide-prev') && window.innerWidth < 1025) {
          swiper.slidePrev();
        }

        if (event.target.classList.contains('swiper-slide-next') && window.innerWidth < 1025) {
          swiper.slideNext();
        }

        if (event.target.classList.contains('swiper-slide') && window.innerWidth >= 1025) {
          const index = parseInt(event.target.getAttribute('data-swiper-slide-index'), 10);

          swiper.slideTo(index);
          swiper.slideNext(0, false);
          swiper.slidePrev(0, false);
          swiper.update();
        }
      });

      swiper.update();

      return swiper;
    }
  }

  customElements.define('product-stories', ProductStories);
}